import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import pt_BR from '../languages/pt-BR'
import es_cl from '../languages/cl'

import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { pt_BR, es_cl },
        current: es_cl,
    },
    theme: {
        options: {
            customProperties: true,
        },
        icons: {
            iconfont: 'mdi', // default - only for display purposes
        },
        themes: {
            light: {
                primary: colors.orange.darken3,
                secondary: colors.grey.darken1,
                accent: colors.shades.black,
                error: colors.red,
                background: '#eee',
            },
            dark: {
                primary: colors.orange.darken3,
                background: '#424242',
            },
        },
    }
})
